<div class="field">
    <label [for]="inputId()">{{ label() }}</label>
    <cl-input-number [inputId]="inputId()" [formControl]="control()" />
    <app-form-error [errors]="control().errors" [visible]="control().touched && !!control().errors" />
</div>
